export default __webpack_public_path__ + "static/media/download.87195c73.svg";